export const youtubeVideoRegEx = /^http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?(?:&[\w\?‌​=]*)*$/i;

export const isValidYoutubeUrl = (url: string = '') => {
  return youtubeVideoRegEx.test(url);
};
